export default __webpack_public_path__ + "static/media/nutritionfacts@2x.11f47893.jpg";